import axios from 'axios';

const getTransactionUpdates = async (url, resAuthenticate, bearer) => {
  return axios.get(
    url + `transaction/${resAuthenticate.transactionId}/updates`,
    {
      headers: {
        accept: 'application/json',
        'x-3ds-api-key': '78a19f216d26440892cca3d031e62e20',
        'x-3ds-correlation-id': resAuthenticate.correlationId,
        'x-3ds-transaction-id': resAuthenticate.transactionId,
        authorization: bearer,
      },
    }
  );
};

const getResChallenge = async (url, resAuthenticate, bearer) => {
  return axios.get(
    url + `transaction/${resAuthenticate.transactionId}/updates`,
    {
      headers: {
        accept: 'application/json',
        'x-3ds-api-key': '78a19f216d26440892cca3d031e62e20',
        'x-3ds-correlation-id': resAuthenticate.correlationId,
        'x-3ds-transaction-id': resAuthenticate.transactionId,
        'X-3DS-TRANSACTION-UPDATED':
          new Date().toISOString().replace('T', ' ').slice(0, -5) + ' UTC',
        authorization: bearer,
      },
    }
  );
};

export { getTransactionUpdates, getResChallenge };
